import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { analyticsSummaryActions } from 'pages/insights/containers/analyticsSummaryContainer/actions';
import { learnersAnalyticsActions } from 'pages/insights/containers/learnersAnalyticsContainer/actions';
import { quickStatsActions } from 'pages/dashboard/containers/quickStats/actions/quickStats';
import StatsBox from 'components/analytics/statsBox';
import InsightsLoader from 'components/loaders/InsightsLoader';
import { getSiteMetricsInfo, getCurrentTotalSiteLearners, getCurrentMAUs, getPreviousMAUs } from 'selectors';

const LearnersAnalyticsSummary = (props) => {
  const {
    site_daily_metrics,
    site_monthly_metrics,
    total_site_learners,
    current_learners_maus,
    previous_learners_maus,
    dispatch
  } = props;

  useEffect(() => {
    dispatch(quickStatsActions.fetchMAUSQuickStats());
    dispatch(analyticsSummaryActions.fetchSiteMonthlyMetrics({}, stopLoadingMetric));
    dispatch(analyticsSummaryActions.fetchGeneralSiteMetrics({}, stopLoadingMetric));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const [siteMonthlyMetricsLoaded, setSiteMonthlyMetricsLoaded] = React.useState(false);
  const [siteGeneralMetricsLoaded, setSiteGeneralMetricsLoaded] = React.useState(false);

  const stopLoadingMetric = (key) => {
    if (key === 'siteMonthlyMetrics') {
      setSiteMonthlyMetricsLoaded(true);
    } else if (key === 'generalSiteMetrics') {
      setSiteGeneralMetricsLoaded(true);
    }
  };

  return siteMonthlyMetricsLoaded && siteGeneralMetricsLoaded ? (
    <Row className="learner-analytics-stats">
      <Col xs="12" md="6" lg="4" className="mb-4">
        <StatsBox
          value={total_site_learners}
          label="Total Learners"
          description="Number of learners who have registered on the platform since launch."
        />
      </Col>

      <Col xs="12" md="6" lg="4" className="mb-4">
        <StatsBox
          value={
            site_monthly_metrics.current_month.new_learners ? site_monthly_metrics.current_month.new_learners : '0'
          }
          label="New Learner Registrations (Current Month)"
          description="Number of learners who have registered during the current calendar month."
        />
      </Col>

      <Col xs="12" md="6" lg="4" className="mb-4">
        <StatsBox
          value={site_monthly_metrics.last_month.new_learners ? site_monthly_metrics.last_month.new_learners : '0'}
          label="New Learner Registrations (Last Month)"
          description="Number of learners who have registered during the last calendar month."
        />
      </Col>

      <Col xs="12" md="6" lg="4" className="mb-4">
        <StatsBox
          value={current_learners_maus}
          label="Monthly Active Learners (Current Month)"
          description="Numbers of learners who were active in the current calendar month."
        />
      </Col>

      <Col xs="12" md="6" lg="4" className="mb-4">
        <StatsBox
          value={previous_learners_maus}
          label="Monthly Active Learners (Last Month)"
          description="Numbers of learners who were active in the last calendar month."
        />
      </Col>

      <Col xs="12" md="6" lg="4" className="mb-4">
        <StatsBox
          value={site_daily_metrics.todays_active_learners_count}
          label="Active Learners Today"
          description="Numbers of learners who were active today."
        />
      </Col>
    </Row>
  ) : (
    <InsightsLoader />
  );
};

function mapStateToProps(state) {
  const current_learners_maus = getCurrentMAUs(state);
  const previous_learners_maus = getPreviousMAUs(state);
  const total_site_learners = getCurrentTotalSiteLearners(state);
  const { site_daily_metrics, site_monthly_metrics } = getSiteMetricsInfo(state);

  return {
    total_site_learners,
    current_learners_maus,
    previous_learners_maus,
    site_daily_metrics,
    site_monthly_metrics
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    ...bindActionCreators(learnersAnalyticsActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LearnersAnalyticsSummary);
